export default __webpack_public_path__ + "static/media/img-0327-botswana-full-face.419f3b96.png";